
import { ProgramSteps } from "../../store/backend";
import { cToF } from "../../utils";
import { observer } from "mobx-react-lite";
import { useStore } from "../../store";

export type StepItemProps = {
  programStep: ProgramSteps
  unit?: 'C' | 'F' | undefined
};




const StepItem = (props: StepItemProps) => {

  const { dataStore } = useStore();

  const unit = dataStore.resData.loadSettingAck?.temperatureUnit === 'F' ? '℉' : '℃'

  let time = "";


  if (props.programStep.day === -1) {

    time = '∞'

  } else {


    if (Number(props.programStep.day) >= 0 && Number(props.programStep.day) < 10) {
      time += ("0" + props.programStep.day).substr(-2) + "d:";
    } else {
      time += (props.programStep.day === -1 ? '∞' : props.programStep.day) + "d:";
    }

    if (Number(props.programStep.hour) >= 0 && Number(props.programStep.hour) < 10) {
      time += ("0" + props.programStep.hour).substr(-2) + "h:";
    } else {
      time += props.programStep.hour + "h:";
    }

    if (Number(props.programStep.minutes) >= 0 && Number(props.programStep.minutes) < 10) {
      time += ("0" + props.programStep.minutes).substr(-2) + "m";
    } else {
      time += props.programStep.minutes + "m";
    }

  }


  return (
    <div className="flex flex-col bg-[red] h-[100px] w-[330px] " style={{ borderColor: 'white', borderRadius: 20, borderWidth: 2, overflow: 'hidden' }}>
      <div className={`${`bg-stepColor${props.programStep.step}`} w-full h-[47px] flex items-center`}>
        <div className="text-[32px] font-bold ml-[10px]"  >{`Step ${props.programStep.step}`}</div>
      </div>
      <div className="flex-1 bg-[white]" />
      <div className="bg-quickStartPrimaryBgColor w-full h-[47px] flex items-center">
        <div className="text-[32px] ml-[10px] font-[400] " style={{opacity:0.8}}  > {unit === '℉' ? cToF(props.programStep.temperature) : props.programStep.temperature}{unit} @ {time}</div>
      </div>
    </div>
  )
}

export default observer(StepItem)

